import React from 'react'
import { motion, useScroll } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/free-mode";

import { Navigation, Pagination, Autoplay} from "swiper/modules";

import { RxArrowRight } from "react-icons/rx";
import { FaLinkedin, FaGithub, FaRobot, FaTrophy, FaClock, FaLaptop, FaLaughSquint, FaCertificate } from "react-icons/fa"
import { IoMdMail } from "react-icons/io"

import {cert} from '../data/certificates'
import {projects} from '../data/projects'
import {timelines} from '../data/timeline'


type GreetProps = {
    name : string
}

type TimelineProps = {
  text_above : boolean
  text : string
  date : string
  color: string
}


type BlogCardProps = {
  title : string
  desc: string 
  date: string 
  color: string 
  read_time: string
  link : string
  category: string
  image: string
}

export const Greet = (props : GreetProps) => {

  //   const blogCards1=[
  //   <BlogCard title='AirFlow Web Srapping' desc='Final Project Winner' date='Dec 20, 2023' members='Team' read_time='3 min read' link='https://github.com' category='Data Engineering' image='promag-logo.jpeg'/>,
  //   <BlogCard title='Tiket.com Reviews Analyzer' desc='Final Project Winner' date='Dec 20, 2023' members='Team' read_time='10 min read' link='https://github.com' category='Data Engineering' image='promag-logo.jpeg'/>,
  //   <BlogCard title='WaveUNet : Audio Source Separation' desc='Final Project Winner' date='Dec 20, 2023' members='Team' read_time='12 min read' link='https://github.com' category='Data Engineering' image='promag-logo.jpeg'/>,
  //   <BlogCard title='AirFlow Web Srapping' desc='Final Project Winner adnajsdnadjadandansdknadnoaqwdoQPNDPQWDNQNDPQNWPDAWDWKNDASNDKNASLLSANCKSNadnajsdnadjadandansdknadnoaqwdoQPNDPQWDNQNDPQNWPDAWDWKNDASNDKNASLLSANCKSN' date='Dec 20, 2023' members='Team' read_time='3 min read' link='https://github.com' category='Data Engineering' image='promag-logo.jpeg'/>,
  //  ]

    const { scrollYProgress } = useScroll();

    return (
      <>
      
      <motion.div className='progress-bar' style={{ scaleX: scrollYProgress }} />  
      <div className='flex flex-col overflow-x-clip cursor-default'>
        
        <div className={`w-[100%] h-[100%] justify-center grid grid-flow-col-dense grid-cols-3 gap-2 container mx-auto items-center px-6 mt-16`}>
          
        
            <div className={`bottom-full flex flex-col gap-1 row-start-1 col-start-1 col-span-3 row-span-1`}>
              
              <motion.div initial="hidden"
                whileInView="visible"
                viewport={{ once: false }}
                transition={{ duration: 0.5 }}
                variants={{
                  visible: { y: 0, opacity: 1 },
                  hidden: { y: -100, opacity: 0}
                }} className='flex flex-col p-3'>
                <img src="foto_formal.png" alt="profile_pic" className='h-32 w-24 rounded-full'/>
                <span className="text-4xl text-start font-bold align-middle">Jonathan Jordan</span>
                <span className="text-base text-start font-semibold align-middle">Certified machine learning developer with expertise in NLP, Data Engineering, and Cloud Computing Solutions</span>
              </motion.div>

              <div className='flex flex-row'>
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false }}
                    transition={{ duration: 0.4 }}
                    variants={{
                      visible: { x: 0, opacity:1 },
                      hidden: { x: -120, opacity:0}
                    }} className={`p-3 align-middle flex flex-col gap-1`}>

                    {/* <span className="text-2xl text-start font-bold align-top">Contacts</span> */}
                    <div className='flex flex-col gap-3'>
                      <div className='flex flex-row gap-1 cursor-pointer hover:text-blue-600 hover:text-lg hover:font-bold' onClick={()=>window.open('https://linkedin.com/in/jonathanjordan21')}>
                      <FaLinkedin size="1.3em" /> <span className='font-semibold'>Linkedin</span><br/>
                      </div>
                      <div className='flex flex-row gap-1 cursor-pointer hover:text-gray-800 hover:text-lg hover:font-bold' onClick={()=>window.open('https://github.com/jonathanjordan21')}>
                      <FaGithub size="1.3em" /> <span className='font-semibold'>Github</span><br/>
                      </div>
                      <div className='flex flex-row gap-1 cursor-pointer hover:text-green-500 hover:text-lg hover:font-bold' onClick={()=>window.open('https://huggingface.co/spaces/jonathanjordan21/chat_with_me')}>
                      <FaRobot size="1.3em" /> <span className='font-semibold'>AI Chatbot of Me</span><br/>
                      </div>
                      <div className='flex flex-row gap-1 cursor-pointer hover:text-yellow-500 hover:text-lg hover:font-bold' onClick={()=>window.open('https://huggingface.co/jonathanjordan21')}>
                      <FaLaughSquint size="1.3em" /> <span className='font-semibold'>HuggingFace</span><br/>
                      </div>
                      <div className='flex flex-row gap-1 cursor-pointer hover:text-red-500 hover:text-base hover:font-bold' onClick={()=>''}>
                      <IoMdMail size="1.3em" /> <span className='font-semibold text-sm'>jonathanjordan210602@gmail.com</span><br/>
                      </div>

                    </div>
                  </motion.div>

                  <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false }}
                    transition={{ duration: 1.5 }}
                    variants={{
                      visible: { x: 0, opacity:1 },
                      hidden: { x: 150, opacity:0}
                    }} className={`md:px-6 align-middle hidden md:flex md:flex-col container gap-1`}>
                    
                    <iframe title="My home" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d507.5255361114302!2d106.7190214242848!3d-6.122099180494664!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e6a02b43848c033%3A0x7468336bf2e6fe4c!2sJl.%20Bima%20No.6%2C%20RT.6%2FRW.7%2C%20Tegal%20Alur%2C%20Kec.%20Kalideres%2C%20Kota%20Jakarta%20Barat%2C%20Daerah%20Khusus%20Ibukota%20Jakarta%2011820!5e0!3m2!1sid!2sid!4v1703672327101!5m2!1sid!2sid" allowFullScreen={true} loading="lazy" referrerPolicy="no-referrer-when-downgrade"
                      className="rounded-[32px] row-start-2 col-start-2 col-span-2 h-48 w-full p-3 border-white md:w-full"></iframe>
                  </motion.div>
                </div>
            </div>
        
          {/* <section className='grid grid-cols-3 grid-rows-6 gap-1 mx-3 h-fit'>
            <div className='p-3 border rounded-[12px] box_bento1 align-middle flex flex-col gap-1 row-span-3 col-span-1 row-start-1 col-start-1'>
              <img src="logo192.png" alt="profile_pic" className='h-24 w-24'/>
              <span className="text-2xl text-start font-bold align-middle">Jonathan Jordan</span>
              <span className="text-base text-start font-semibold align-middle">Certified machine learning developer with expertise in NLP, Data Engineering, and Cloud Computing Solutions</span>
            </div>
            <div className='p-3 border box_bento1 rounded-[12px] flex flex-col gap-1 col-span-1 row-start-1 col-start-2 row-span-3'>
              <embed title="Github" src="https://www.youtube.com/jonathanjordan21"></embed>
              <span className='text-lg font-bold'>LinkedIn</span>
              <span className='text-sm font-medium'>Profiency of AirFlow and PySpark</span>
            </div>

            <div className='p-3 border box_bento1 rounded-[12px] flex flex-col gap-1 col-span-1 row-span-4 row-start-1 col-start-3'>
              <span className="font-semibold text-center">Tech Stack</span>
            </div>

            <div className='p-3 border box_bento1 rounded-[12px] row-start-4 col-start-1 row-span-2 col-span-2'>
              <span className="text-2xl font-bold text-center text-yellow-300">Awards</span><br/>
                <span className='font-bold text-lg text-yellow-500'>1st Place </span><span className='font-medium text-base'>The Best Team Data Academy</span><br/>
                <span className='font-bold text-lg text-yellow-200'>2nd Place </span><span className='font-medium text-base'>KOMPRES 14 -Community Based App-</span><br/>
                <span className='font-bold text-medium text-neutral-200'>International Certificate</span><span className='font-medium text-base'> TensorFlow Developer</span><br/>
                <span className='font-bold text-medium text-green-400'>Scholarship</span><span className='font-medium text-base'> of Gunadarma University in 3rd Semester</span><br/>
            </div>

            <div className='p-3 border box_bento1 rounded-[12px] flex flex-col gap-1 row-start-5 col-start-3 row-span-1 col-span-1'>
              <span className="text-base font-semibold text-start">Contacts :</span><br/>
              <div className='flex flex-row gap-3'>
                <FaLinkedin size="1.3em" />
                <FaGithub size="1.3em" />
                <FaWhatsapp size="1.3em" />
                <IoMdMail size="1.3em" />
              </div>

            </div>
            
            
          </section> */}

          {/* <h1 className='text-6xl'>Jonathan Jordan</h1><br/>
          <h3 className='text-xl mx-10'>Certified Machine Learning Developer</h3> */}
        </div>

        <div className={`p-3 rounded-[12px] flex flex-col gap-1 items-center container mx-auto mt-12`}>
              <motion.div 
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false }}
                transition={{ duration: 0.2 }}
                variants={{
                  visible: { scale: 1 },
                  hidden: {scale: 0 }
                }} className='flex flex-col items-center gap-1 p-3 mx-auto'>
                <FaTrophy size="6em" color='yellow'/>
                <span className="text-4xl text-center font-bold align-middle">Awards</span>
              </motion.div>

              <motion.div initial="hidden"
                whileInView="visible"
                viewport={{ once: false }}
                transition={{ duration: 0.4 }}
                variants={{
                  visible: { x: 0, opacity:1 },
                  hidden: { x: -200, opacity:0 }
                }} className='mt-3'>
              <div className='p-1 my-1'>➤ <span className='font-bold text-lg hover:text-2xl text-yellow-500'>1st Place </span><span className='font-medium text-base'>The Best Team Data Engineering Academy</span></div>
              <div className='p-1 my-1'>➤ <span className='font-bold text-lg hover:text-2xl text-yellow-200'>2nd Place </span><span className='font-medium text-base'>KOMPRES 14 -Community Based App-</span></div>
              <div className='p-1 my-1'>➤ <span className='font-bold text-medium hover:text-xl text-slate-500'>International Certificate</span><span className='font-medium text-base'> TensorFlow Developer</span></div>
              <div className='p-1 my-1'>➤ <span className='font-bold text-medium hover:text-xl text-green-400'>Scholarship</span><span className='font-medium text-base'> of Gunadarma University in 3rd Semester</span></div>
              </motion.div>
            </div>

        
           


       
        
        <div style={{backgroundImage: "https://i.pinimg.com/originals/f9/6d/fb/f96dfb9f9d4e0b42af3888de8b9473a7.gif"}} className={`w-[100%] h-[100%] justify-center flex flex-col container items-center mx-auto`}>
           <div className={`p-3 flex flex-col gap-1 row-start-1 col-start-1 items-center col-span-3 row-span-1 w-full mt-12 mx-28`}>
              <motion.div 
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false }}
                transition={{ duration: 0.2 }}
                variants={{
                  visible: { scale: 1 },
                  hidden: {scale: 0 }
                }} className='flex flex-col items-center gap-1 p-3 mx-auto'>
                <FaLaptop size="6em" color='gray'/>
                <span className="text-4xl text-center font-bold align-middle">Projects</span>
              </motion.div>

              <motion.div
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false }}
                transition={{ duration: 0.5 }}
                variants={{
                  visible: { x: 0, opacity: 1 },
                  hidden: { x: 150, opacity: 0}
                }} className="flex flex-row h-fit w-96 md:w-[100%] overflow-y-auto mt-6 overflow-x-auto justify-end container md:px-auto items-center scroll-smooth focus:scroll-auto">
                {/* <Project title='AirFlow' desc='Promag' color='text-yellow-700' link="" image_url=''/>
                <Project title='AirFlow' desc='Promag' color='text-yellow-700' link="" image_url=''/> */}
                <Swiper 

                  style={{
                    '--swiper-navigation-color': '#fff',
                    '--swiper-pagination-color': '#fff'
                  }}

                  spaceBetween={21}
                  centeredSlides={true}

                  
                  pagination={{
                    clickable: true,
                  }}

                  navigation={true}

                  loop={true}

                  autoHeight={true}


                  autoplay={{
                    delay:5000,
                    delayOnInteraction:false
                  }}
                  modules={[Pagination, Navigation, Autoplay]}
                > 
                  {projects.map(({title, desc, date, read_time, link, category, image, color}, index)=>{
                    return (<SwiperSlide key={index}>
                      <div className="relative group" onClick={()=>window.open(link)}>

                        <BlogCard title={title} desc={desc} date={date}
                          color={color} 
                          read_time={read_time}
                          link={link}
                          category={category}
                          image={image}/>

                        <div className={`cursor-pointer absolute inset-0 bg-gradient-to-r max-w-full rounded-md from-orange-300 via-neutral-500 to-blue-400 opacity-0 group-hover:opacity-70`} 
                          
                        />
                        <div className={`absolute text-white inset-0 flex items-center justify-center cursor-pointer opacity-0 group-hover:opacity-100 transition-all`}>
                          View Project
                          <RxArrowRight className="ml-2 w-[24px] h-[24px]" />
                        </div>
                      </div>
                      
                    </SwiperSlide>)
                  })}
                </Swiper> 
                {/* <BlogCard title='AirFlow Web Srapping' desc='Final Project Winner' date='Dec 20, 2023' members='Team' read_time='3 min read' link='https://github.com' category='Data Engineering'/>
                <BlogCard title='Tiket.com Reviews Analyzer' desc='Final Project Winner' date='Dec 20, 2023' members='Team' read_time='10 min read' link='https://github.com' category='Data Engineering'/>
                <BlogCard title='WaveUNet : Audio Source Separation' desc='Final Project Winner' date='Dec 20, 2023' members='Team' read_time='12 min read' link='https://github.com' category='Data Engineering'/>
                <BlogCard title='AirFlow Web Srapping' desc='Final Project Winner adnajsdnadjadandansdknadnoaqwdoQPNDPQWDNQNDPQNWPDAWDWKNDASNDKNASLLSANCKSN' date='Dec 20, 2023' members='Team' read_time='3 min read' link='https://github.com' category='Data Engineering'/>
                <BlogCard title='AirFlow Web Srapping' desc='Final Project Winner' date='Dec 20, 2023' members='Team' read_time='3 min read' link='https://github.com' category='Data Engineering'/>
                <BlogCard title='AirFlow Web Srapping' desc='Final Project Winner' date='Dec 20, 2023' members='Team' read_time='3 min read' link='https://github.com' category='Data Engineering'/>
                <BlogCard title='AirFlow Web Srapping' desc='Final Project Winner' date='Dec 20, 2023' members='Team' read_time='3 min read' link='https://github.com' category='Data Engineering'/> */}
            </motion.div>
              
            </div>
        </div>

        <div className='w-[100%] h-[100%] mt-12'>
          <motion.div 
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false }}
              transition={{ duration: 0.2 }}
              variants={{
                visible: { y:50, scale: 1 },
                hidden: {scale: 0 }
              }} className='flex flex-col items-center gap-1 p-3 mx-auto'>
              <FaCertificate size="6em" className='text-blue-600'/>
              <span className="text-4xl text-center font-bold align-middle mb-12">Certificates</span>
            </motion.div>
          <div>
              <motion.div initial="hidden"
                whileInView="visible"
                viewport={{ once: false }}
                transition={{ duration: 0.4 }}
                variants={{
                  visible: { x: 0, opacity:1 },
                  hidden: { x: -200, opacity:0 }
                }} className='flex flex-row h-fit w-96 md:w-[100%] overflow-y-auto mt-6 overflow-x-auto justify-end container mx-auto items-center scroll-smooth focus:scroll-auto'>

                <Swiper 

                  style={{
                    '--swiper-navigation-color': '#fff',
                    '--swiper-pagination-color': '#fff'
                  }}

                  // spaceBetween={21}
                  centeredSlides={true}

                  
                  pagination={{
                    clickable: true,
                  }}

                  navigation={true}

                  loop={true}

                  autoHeight={true}


                  autoplay={{
                    delay:1000,
                    delayOnInteraction:false
                  }}
                  modules={[Pagination, Navigation, Autoplay]}
                > 
                  {cert.map(({lms, title, color, image}, index) => (
                    <SwiperSlide key={`cert ${index}`}>
                      <div className="relative group">
                        <div className='flex flex-col items-center justify-items-center container mx-auto h-fit w-full text-center bg-transparent shadow-2xl p-6'>
                          <img className='h-24 w-24 justify-center rounded-full mb-6' src={image} alt={`coursera ${index}`}/>
                          <div className='mb-4'>
                              <span className={`font-bold text-lg hover:text-xl ${color}`}>{lms} : </span><span className='font-medium text-base'>{title}</span>
                              <div className={`cursor-pointer absolute inset-0 bg-gradient-to-r max-w-full rounded-md from-orange-300 via-neutral-500 to-blue-400 opacity-0 group-hover:opacity-70`}/>
                              <div className={`absolute text-white inset-0 flex items-center justify-center cursor-pointer opacity-0 group-hover:opacity-100 transition-all`} onClick={()=>window.open("https://drive.google.com/drive/u/0/folders/1hL2TkhfIU4-LnmT81ktxvX7XSEPJIm0w")}>
                                View Certificates
                              <RxArrowRight className="ml-2 w-[24px] h-[24px]" />
                        </div>

                          </div>
                        </div>
                      </div>
                      
                    </SwiperSlide>
                  ))}
                </Swiper> 
                  

              </motion.div>
            </div>
            

        </div>


        <div className={`w-[100%] h-[100%] justify-center flex flex-col items-center mt-12`} >
              <motion.div 
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false }}
                transition={{ duration: 0.2 }}
                variants={{
                  visible: { y:50, scale: 1 },
                  hidden: {scale: 0 }
                }} className='flex flex-col items-center gap-1 p-3 mx-auto'>
                <FaClock size="6em" color='red'/>
                <span className="text-4xl text-center font-bold align-middle mb-6">Timeline</span>
              </motion.div>
            {/* <div className={`w-400 h-400 justify-center flex flex-row items-center transition-all ease-in duration-700 
            ${isVisible2 ? "opacity-100" : "opacity-0"} ${isVisible2 ? "ml-0" : "ml-96"}`}>
              <span className="relative flex h-3 w-3 m-12">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-slate-200 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-3 w-3 bg-black"></span>
              </span>
              <h6>text</h6>
            </div> */}
            {/* <Test /> */}
            <motion.div
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false }}
              transition={{ duration: 0.3 }}
              variants={{
                visible: { opacity: 1 },
                hidden: { opacity: 0},
              }} className={`flex flex-col w-fit justify-center container items-center p-12`}>

                {timelines.map(({text, date, color}, idx)=><Timeline text_above={idx % 2 === 0} text={text} date={date} color={color} />)}
                {/* <Timeline text_above={true} text="Attend College in Gunadarma University" date="Sep 2020" color="text-white" />
                <Timeline text_above={false} text="2nd Place -CommunityBased- Gunadarma Competition" date="Jan 2022"  color="text-yellow-300" />
                <Timeline text_above={true} text="Joined Bangkit Academy : Machine Learning" date="Feb 2023"  color="text-white" />
                <Timeline text_above={false} text="Achieved TensoFlow Developer Certificate" date="Aug 2023"  color="text-green-400" />
                <Timeline text_above={true} text="Joined Data Academy :  Data Engineering" date="Aug 2023" color="text-white" />
                <Timeline text_above={false} text="Joined Lintas Media Danawa : AI Engineer Intern" date="Oct 2023" color="text-blue-500" />
                <Timeline text_above={true} text="1st Place -FinalProject- Data Academy" date="Dec 2023" color="text-yellow-300" /> */}
            </motion.div>
        </div>

        {/* <div ref={ref3} className={`w-[100%] h-[100%] justify-center flex flex-row items-center transition-all ease-in duration-700 
        ${isVisible3 ? "opacity-100" : "opacity-0"}`}>
            <h2 className="text-4xl font-bold text-center">Projects</h2>
        </div> */}
        
        {/* <div>
            <h2 className="text-8xl font-bold text-center">Weclome2 {props.name}! </h2>
        </div> */}
        <iframe
          title="Chat with me"
          src="https://jonathanjordan21-chat-with-me.hf.space"
          frameBorder="0"
          height="600"
          className={`w-[100%] justify-center flex flex-col items-center mt-12`}
        ></iframe>

      </div>
      </>
    )
}


const Timeline = ({text_above, text, date, color} : TimelineProps) => {
  return !text_above ? (
    <motion.div initial="hidden"
      whileInView="visible"
      viewport={{ once: false }}
      transition={{ duration: 0.5 }}
      variants={{
        visible: { x: 0, opacity: 1 },
        hidden: { x: 150, opacity: 0}
      }} className={`grid grid-cols-3 w-80 justify-center items-center`}>
      <div className='flex flex-col mb-11'>
        {/* <h6 className='m-3 text-xs text-end'> {date} </h6> */}
        {/* <div className="vl justify-self-center mr-0"></div> */}
      </div> 
      <span className="relative grid grid-rows-4 h-3 w-3 justify-self-center mb-11">
        {/* <div className="vl justify-self-center mr-0"></div> */}
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-yellow-300 opacity-75"></span>
        {/* <div className="vl2 justify-self-center mr-0"></div> */}
        <span className="relative inline-flex rounded-full h-3 w-3 bg-yellow-500"></span>
        {/* <div className="vl justify-self-center mr-0"></div> */}
        <h6 className='m-3 text-xs'> {date} </h6>
        {/* <div className="vl2 justify-self-center mr-8 h-[100%]"></div> */}
        
      </span>
      <div className='flex flex-cols justify-self-start mb-11'>
        {/* <h6 className='m-3 text-xs text-end'> {date} </h6> */}
        <h6 className={`text-left text-base font-semibold transition-all ease-in duration-700 ${color}`}>{text}</h6>
        
      </div> 
      
    </motion.div>
  ) : (
    <motion.div initial="hidden"
    whileInView="visible"
    viewport={{ once: false }}
    transition={{ duration: 0.5 }}
    variants={{
      visible: { x: 0, opacity: 1 },
      hidden: { x: -150, opacity: 0}
    }} className={`grid grid-cols-3 w-80 justify-center items-center`}>
      <div className={`flex flex-rows justify-self-end mb-11`}>
        {/* <h6 className='m-3 text-xs text-end'> {date} </h6> */}
        
        <h6 className={`text-base justify-self-end font-semibold text-end ${color}`} >{text}</h6>
        
      </div> 
      
      <span className="relative h-3 w-3 justify-self-center grid grid-rows-4 mb-11">
        
        {/* <div className="vl justify-self-center align-top mr-0"></div> */}
        
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-yellow-300 opacity-75"></span>
        <span className="relative inline-flex rounded-full h-3 w-3 bg-yellow-500"></span>
        <h6 className='m-3 text-xs justify-self-start'> {date} </h6>
        {/* <div className="vl2 justify-self-center mr-11 h-[100%]"></div> */}
        
      </span>
      {/* <div className="vl justify-self-start"><h6 className='m-3 text-xs'> {date} </h6></div> */}
      <div className='flex flex-cols justify-self-start mb-11'>
        {/* <h6 className='m-3 text-xs text-end'> {date} </h6> */}
        {/* <div className="vl justify-self-end"></div> */}
      </div> 
    </motion.div>
  )
}



const BlogCard = ({title, desc, date, read_time, category, image, color} : BlogCardProps) => {
  const border_color = 'border-'+color;
  const text_color = 'text-'+color;
  return (
    <div className="mb-4 p-0 sm:p-0 md:w-full h-fit text-start"> {/* Card container */}
      <div className={`group h-full rounded-lg bg-transparent overflow-hidden shadow-lg md:flex md:flex-row`}>

        {/* :CARD IMAGE */}
        <img className="md:h-72 h-36 w-full object-cover object-center transition-all duration-500 ease-in-out transform group-hover:scale-105" src={image} alt="blog"/>

        {/* :CARD CATEGORY */}
        <div className='flex flex-col'>
          <h2 className="pt-4 pb-1 px-6 inline-block title-font text-xs font-semibold text-red-300 uppercase tracking-widest cursor-pointer hover:font-bold">{category}</h2>

          {/* :CARD BODY */}
          <div className="py-1 px-6 overflow-y-clip">
            {/* ::Card title */}
            <h1 className={`mb-3 inline-block title-font text-xl font-extrabold ${text_color} tracking-wide cursor-pointer overflow-y-clip`}>{title}</h1>
            {/* ::Card excerpt */}
            <p className="line-clamp-6 mb-3 overflow-hidden leading-relaxed text-gray-300 cursor-pointer">{desc}</p>
          </div>

          {/* :CARD FOOTER */}
          <div className="pt-1 pb-4 px-6 flex justify-between items-center flex-wrap">
            {/* ::Date & reading time */}
            <div className="flex flex-wrap text-sm text-red-200">
              <span className="mr-1">{date}</span>
              <span className="">&#183; {read_time}</span>
            </div>
          </div>
        </div>

      </div>
    </div>
  )
}
